import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const LibraryListIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 24 21"
    style={{ fill: 'none', width: '24', height: '21', strokeWidth: '.09rem' }}
  >
    <path d="M2.91667 4.74911C3.97521 4.74911 4.83333 3.89098 4.83333 2.83244C4.83333 1.77389 3.97521 0.915771 2.91667 0.915771C1.85812 0.915771 1 1.77389 1 2.83244C1 3.89098 1.85812 4.74911 2.91667 4.74911Z" />
    <path d="M8.66669 2.83252H23.0417" />
    <path d="M2.91667 12.4159C3.97521 12.4159 4.83333 11.5577 4.83333 10.4992C4.83333 9.44064 3.97521 8.58252 2.91667 8.58252C1.85812 8.58252 1 9.44064 1 10.4992C1 11.5577 1.85812 12.4159 2.91667 12.4159Z" />
    <path d="M8.66669 10.499H23.0417" />
    <path d="M2.91667 20.0824C3.97521 20.0824 4.83333 19.2242 4.83333 18.1657C4.83333 17.1071 3.97521 16.249 2.91667 16.249C1.85812 16.249 1 17.1071 1 18.1657C1 19.2242 1.85812 20.0824 2.91667 20.0824Z" />
    <path d="M8.66669 18.1658H23.0417" />
  </SvgIcon>
);

export default LibraryListIcon;
